import type React from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import type { TierFeatureType } from './TiersSection';

const TierCardFeatureLine: React.FC<TierFeatureType> = ({
  id,
  tier,
  included,
  highlight,
  selected,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <span className="min-w-full flex flex-row items-center justify-center p-1 gap-3">
      <span className="min-w-3 max-w-3 min-h-3 max-h-3 flex flex-col items-center text-center justify-center">
        {included ? (
          <FaCheck size={22} className="text-green-500" />
        ) : (
          <AiOutlineClose size={22} className="text-slate-500" />
        )}
      </span>
      <span
        className={`grow flex flex-col items-start text-start justify-center ${highlight ? 'font-bold' : included ? 'font-light' : 'text-slate-500 line-through'}`}
      >
        {t(
          `static.prices.account_tier_card_feature_description_tier_${tier.valueOf()}_feature_${id}`,
        )}
      </span>
    </span>
  );
};

export default TierCardFeatureLine;
